import { request } from '@easytwin/runtime';
import {
  apis,
  BatchUpdateOfficialResourceDto,
  CreateOfficialResourceCategoryDto,
  CreateOfficialResourceDto,
  UpdateOfficialResourceCategoryDto,
  UpdateOfficialResourceDto,
} from '@easytwin/types';

/** 编辑器页获取资产库用 */
const getOfficialResources = (categoryIds?: number[]) => {
  return request(apis.officialResourcesGet, { query: { categoryIds } });
};

/** 后台管理页获取资产库用 */
const getOfficialResourcesAll = (categoryIds?: number[]) => {
  return request(apis.officialResourcesAllGet, { query: { categoryIds } });
};

const createOfficialResource = (dto: CreateOfficialResourceDto) => {
  return request(apis.officialResourcesPost, {
    body: dto,
  });
};

const deleteOfficialResources = (ids: number[]) => {
  return request(apis.officialResourcesDelete, {
    query: { ids },
  });
};

const updateOfficialResource = (id: number, dto: UpdateOfficialResourceDto) => {
  return request(apis.officialResourceIdPatch, {
    params: { id },
    body: dto,
  });
};

const updateOfficialResources = (dto: BatchUpdateOfficialResourceDto) => {
  return request(apis.officialResourcesPatch, {
    body: dto,
  });
};

const getOfficialResourceCategory = () => {
  return request(apis.officialResourcesCategoryGet);
};

const updateOfficialResourceCategory = (id: number, dto: UpdateOfficialResourceCategoryDto) => {
  return request(apis.officialResourcesCategoryIdPatch, {
    params: { id },
    body: dto,
  });
};

const createOfficialResourceCategory = (dto: CreateOfficialResourceCategoryDto) => {
  return request(apis.officialResourcesCategoryPost, { body: dto });
};

const deleteOfficialResourceCategory = (ids: number[]) => {
  return request(apis.officialResourcesCategoryDelete, {
    query: { ids },
  });
};

const addUsedTimes = (id: number) => {
  return request(apis.officialResourcesAddIdUsedTimesPost, {
    params: { id },
  });
};

export const OfficialResourceAPI = {
  addUsedTimes,
  getOfficialResources,
  getOfficialResourcesAll,
  createOfficialResource,
  deleteOfficialResources,
  updateOfficialResource,
  updateOfficialResources,
  getOfficialResourceCategory,
  updateOfficialResourceCategory,
  createOfficialResourceCategory,
  deleteOfficialResourceCategory,
};
